import { Service, BaseService } from "@/core/auto";

@Service('/api/usr/rep')
export default class Report extends BaseService{
    search(data) {
		return this.request({
            data: {
				'condition' : data
			},
			url: "/search",
			method: "POST"
		});
	}

	getReportConfirm(id) {
		const data = {'id': id}
		return this.request({
            data: data,
			url: "/confirm",
			method: "POST"
		});
	}

	getReportSend(id) {
		const data = {'id': id}
		return this.request({
            data: data,
			url: "/send",
			method: "POST"
		});
	}

	update(data, upload1, upload2) {
		const form = new FormData()
	
		for (const key in data) {
			if (data.hasOwnProperty(key)) {
				if (data[key] !== null && data[key] !== undefined){
					if(key == 'submitBeginTm' && data[key]) {
						form.append(key,data[key]);
					} else if (key != 'submitBeginTm') {
						form.append(key,data[key]);
					}
				}
			}
		}
		if (upload1) {
			form.append('upload1', upload1);
		}
		if (upload2) {
			form.append('upload2', upload2);
		}
		return this.request({
			data: form,
			url: "/update",
			method: "POST"
		});
	}
}
